<template>
    <div class="theme-overview">
        <div class="row">
            <div class="col">
                <h2>{{ $t('themeOverview.title') }}</h2>
                <p class="col">
                    {{ $t('themeOverview.introtext') }}
                </p>
                <div class="theme-overview__items d-lg-flex">
                    <radio-item
                        :checked="investmentTopic === InvestmentTopic.NO_THEME"
                        icon="noTheme"
                        :title="$t('themeOverview.NO_THEME.title')"
                        :text="$t('themeOverview.NO_THEME.text')"
                        @click="onSetInvestmentTopic(InvestmentTopic.NO_THEME)" />
                    <radio-item
                        :checked="investmentTopic === InvestmentTopic.TECH_PROGRESS"
                        icon="techProgress"
                        :title="$t('themeOverview.TECH_PROGRESS.title')"
                        :text="$t('themeOverview.TECH_PROGRESS.text')"
                        @click="onSetInvestmentTopic(InvestmentTopic.TECH_PROGRESS)" />
                    <radio-item
                        :checked="investmentTopic === InvestmentTopic.DIVIDENDS"
                        icon="dividends"
                        :title="$t('themeOverview.DIVIDENDS.title')"
                        :text="$t('themeOverview.DIVIDENDS.text')"
                        @click="onSetInvestmentTopic(InvestmentTopic.DIVIDENDS)" />
                    <radio-item
                        :checked="investmentTopic === InvestmentTopic.ENERGY_TRANSITION"
                        icon="energyPolicyTurnaround"
                        :title="$t('themeOverview.ENERGY_TRANSITION.title')"
                        :text="$t('themeOverview.ENERGY_TRANSITION.text')"
                        @click="onSetInvestmentTopic(InvestmentTopic.ENERGY_TRANSITION)" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col theme-overview__detail-wrapper">
                <transition-group
                    name="fade"
                    mode="in-out">
                    <template
                        v-for="theme in themes">
                        <div
                            class="theme-overview__detail"
                            :key="theme.type"
                            v-if="investmentTopic === theme.type">
                            <Carousel
                                :options="flickityOptions">
                                <theme-carousel-slide
                                    type="image"
                                    :img-src="theme.img"
                                    :title-icon-type="theme.icon"
                                    :title="$t(`themeOverview.${theme.type}.carousel.slide1.title`)"
                                    :text="$t(`themeOverview.${theme.type}.carousel.slide1.text`)"
                                    :width="iconWidth"
                                    :height="iconHeight" />
                                <theme-carousel-slide
                                    type="text"
                                    :title-icon-type="theme.icon"
                                    :title="$t(`themeOverview.${theme.type}.carousel.slide2.title`)"
                                    :text="$t(`themeOverview.${theme.type}.carousel.slide2.text`)"
                                    :width="iconWidth"
                                    :height="iconHeight" />
                                <theme-carousel-slide
                                    type="small-image"
                                    :img-src="theme.smallImg"
                                    :title-icon-type="theme.icon"
                                    :title="$t(`themeOverview.${theme.type}.carousel.slide3.title`)"
                                    :text="$t(`themeOverview.${theme.type}.carousel.slide3.text`)"
                                    :name="$t(`themeOverview.${theme.type}.carousel.slide3.name`)"
                                    :position="$t(`themeOverview.${theme.type}.carousel.slide3.position`)"
                                    :width="iconWidth"
                                    :height="iconHeight" />
                            </Carousel>
                        </div>
                    </template>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
import { InvestmentTopic } from '@/api/enums';
import RadioItem from '@/components/common/RadioItem';

import { mapState, mapActions, mapGetters } from 'vuex';
import Carousel from '@/components/common/Carousel';
import ThemeCarouselSlide from '@/components/ThemeCarouselSlide';

export default {
    name: 'ThemeOverview',
    computed: {
        ...mapState(['investmentTopic']),
        ...mapGetters(['isInEditMode', 'viewportNoMatch']),
        themes () {
            return [
                {
                    type: InvestmentTopic.NO_THEME,
                    img: require('@/assets/images/theme/diverses-370x290.jpg'),
                    smallImg: require('@/assets/images/theme/SachaMarienberg-290x290.jpg'),
                    icon: 'no-theme-slider',
                },
                {
                    type: InvestmentTopic.TECH_PROGRESS,
                    img: require('@/assets/images/theme/Technologischer-Fortschritt-370x290.jpg'),
                    smallImg: require('@/assets/images/theme/SachaMarienberg-290x290.jpg'),
                    icon: 'tech-progress-slider',
                },
                {
                    type: InvestmentTopic.DIVIDENDS,
                    img: require('@/assets/images/theme/dividenden-370x290.jpg'),
                    smallImg: require('@/assets/images/theme/SachaMarienberg-290x290.jpg'),
                    icon: 'dividends-slider',
                },
                {
                    type: InvestmentTopic.ENERGY_TRANSITION,
                    img: require('@/assets/images/theme/energiewende-370x290.jpg'),
                    smallImg: require('@/assets/images/theme/SachaMarienberg-290x290.jpg'),
                    icon: 'energy-transition-slider',
                },
            ];
        },
        iconWidth () {
            return !this.viewportNoMatch ? 49 : 36;
        },
        iconHeight () {
            return !this.viewportNoMatch ? 49 : 36;
        },
    },
    components: {
        RadioItem,
        Carousel,
        ThemeCarouselSlide,
    },
    data () {
        return {
            InvestmentTopic,
            showAlert: false,
            slide: 0,
            sliding: null,
            tabIndex: 1,
            flickityOptions: {
                cellSelector: '.carousel__item',
                // imagesLoaded: true,
                initialIndex: 0,
                prevNextButtons: true,
                pageDots: true,
                wrapAround: false,
                adaptiveHeight: true,
                setGallerySize: false,
                on: {
                    ready () {
                        this.element.classList.remove('carousel--loading');
                    },
                },
            },
        };
    },
    methods: {
        ...mapActions(['setInvestmentTopic']),
        onSetInvestmentTopic (theme) {
            this.setInvestmentTopic(theme);
        },
        imageUrl (imageName) {
            return require('@/assets/images/' + imageName);
        },
    },
    created () {
        if (!this.isInEditMode) {
            this.onSetInvestmentTopic(InvestmentTopic.NO_THEME);
        }
    },
};
</script>

<style scoped lang="scss">
  .theme-overview__items {
    margin-bottom: 20px;

    @include media-breakpoint-down(xs) {
      margin-bottom: 10px;
    }
  }

  ::v-deep .radio-item--checked {
      @include media-breakpoint-down(xs) {
        background: $mb-darkgreen;
      }

      .radio-item__content {
          .radio-item__title {
            @include media-breakpoint-down(xs) {
              color: $white;
            }
          }
      }
  }

  .theme-overview__detail-wrapper {
    position: relative;
    height: 320px;

    @include media-breakpoint-down(xs) {
      overflow-y: hidden;
      height: 285px;
    }
  }

  .theme-overview__detail {
    position: absolute;
    width: 100%;
    padding: 0 7.5px;
    top: 0;
    left: 0;
  }
</style>
